import CarActive from '@/static/assets/products/car_active.svg';
import Car from '@/static/assets/products/car_desktop.svg';
import HomeActive from '@/static/assets/products/homeowners_active.svg';
import Home from '@/static/assets/products/homeowners_desktop.svg';
import PetActive from '@/static/assets/products/pet_active.svg';
import Pet from '@/static/assets/products/pet_desktop.svg';
import Renters from '@/static/assets/products/renters_desktop.svg';
import RentersActive from '@/static/assets/products/renters_desktop_active.svg';

export const PRODUCT_LINE_HOME_US = 'home_us';
export const PRODUCT_HOME_US_HOMEOWNERS = 'home_us_owners';
export const PRODUCT_HOME_US_RENTERS = 'home_us_renters';

export const PRODUCT_LINE_HOME_EU = 'home_eu';
export const PRODUCT_HOME_EU_CONTENTS_AND_LIABILITY = 'home_eu_contents_and_liability';
export const PRODUCT_HOME_EU_CONTENTS_ONLY = 'home_eu_contents';
export const PRODUCT_HOME_EU_LIABILITY_ONLY = 'home_eu_liability';
export const PRODUCT_HOME_EU_HOMEOWNERS = 'home_eu_owners';
export const PRODUCT_HOME_EU_RENTERS = 'home_eu_renters';

export const PRODUCT_PET = 'pet';
export const PRODUCT_LIFE = 'life';
export const PRODUCT_CAR = 'car';
export const PRODUCT_RENTERS = 'renters';
export const PRODUCT_HOME = 'home';

export const PRODUCT_GB_CONTENTS = 'contents';
export const PRODUCT_GB_CRYPTO = 'crypto';

/* eslint-disable @typescript-eslint/naming-convention */
export const Products = {
  PRODUCT_LINE_HOME_US,
  PRODUCT_HOME_US_HOMEOWNERS,
  PRODUCT_HOME_US_RENTERS,
  PRODUCT_LINE_HOME_EU,
  PRODUCT_HOME_EU_CONTENTS_AND_LIABILITY,
  PRODUCT_HOME_EU_CONTENTS_ONLY,
  PRODUCT_HOME_EU_LIABILITY_ONLY,
  PRODUCT_HOME_EU_HOMEOWNERS,
  PRODUCT_HOME_EU_RENTERS,
  PRODUCT_PET,
  PRODUCT_LIFE,
  PRODUCT_CAR,
} as const;
/* eslint-enable @typescript-eslint/naming-convention */

export type Product = (typeof Products)[keyof typeof Products];

export interface BundleProduct {
  readonly name: 'car' | 'homeowners' | 'pet' | 'renters';
  readonly id: string;
  readonly source: 'car' | 'homeowners' | 'pet' | 'renters';
  readonly title: string;
  readonly subtitle: string;
  readonly product: 'car' | 'home_us_owners' | 'home_us_renters' | 'pet';
  readonly defaultImage: string;
  readonly activeImage: string;
}

export const BUNDLE_PRODUCTS: BundleProduct[] = [
  {
    name: 'renters',
    id: 'gtm_button_get_renters',
    source: 'renters',
    title: 'Renters',
    subtitle: 'Coverage for your stuff inside and out of your home',
    product: PRODUCT_HOME_US_RENTERS,
    defaultImage: Renters.src,
    activeImage: RentersActive.src,
  },
  {
    name: 'homeowners',
    id: 'gtm_button_get_general_homeowners',
    source: 'homeowners',
    title: 'Homeowners',
    subtitle: 'Protection for your stuff, plus your actual house',
    product: PRODUCT_HOME_US_HOMEOWNERS,
    defaultImage: Home.src,
    activeImage: HomeActive.src,
  },
  {
    name: 'car',
    id: 'gtm_button_get_car',
    source: 'car',
    title: 'Car',
    subtitle: 'Protect your car, passengers, and the planet',
    product: PRODUCT_CAR,
    defaultImage: Car.src,
    activeImage: CarActive.src,
  },
  {
    name: 'pet',
    id: 'gtm_button_get_pet',
    source: 'pet',
    title: 'Pet Health',
    subtitle: 'Health insurance for furry family members',
    product: PRODUCT_PET,
    defaultImage: Pet.src,
    activeImage: PetActive.src,
  },
];
